import { forwardRef } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import './GlassPill.css';

interface GlassPillProps extends HTMLAttributes<HTMLSpanElement> {
  mono?: boolean;
  children?: ReactNode;
}

export const GlassPill = forwardRef<HTMLSpanElement, GlassPillProps>(function GlassPill(
  { mono = false, className = '', children, ...rest },
  ref
) {
  return (
    <span
      ref={ref}
      data-mono={mono || undefined}
      className={`glass-pill ${className}`.trim()}
      {...rest}
    >
      {children}
    </span>
  );
});
